import { FirstCheckInDateController } from "apps/oneOnboarding/pricing/firstCheckInDate/FirstCheckInDateController";
import { useBatchFirstCheckInDate } from "./useBatchFirstCheckInDate";

export const BatchFirstCheckInDateController = () => {
    const controllerProps = useBatchFirstCheckInDate();

    return <FirstCheckInDateController bulk {...controllerProps} />;
};
